import { usePopupState } from "@/shared/hooks";
import { useFiles } from "@/shared/state/visualization";

import { AddPanel } from "../controls/AddPanel";
import { SelectActiveLayout } from "../controls/SelectActiveLayout";
import { SelectLayout } from "../controls/SelectLayout/SelectLayout";
import {
  useActiveLayout,
  useEphemeralWorkspaceState,
} from "../WorkspaceCtx/hooks";

import styles from "./Header.module.css";
import { HeaderActionsMenu } from "./HeaderActionsMenu";
import { ShareWorkspaceButton } from "./ShareWorkspaceButton";

export function Header() {
  const files = useFiles();
  const { files: fileRecords } = useEphemeralWorkspaceState();
  const [activeLayout] = useActiveLayout();
  const layoutMenuPopup = usePopupState();

  return (
    <>
      <div className={styles.actions}>
        <SelectActiveLayout activeLayout={activeLayout} />
        <AddPanel />
        <ShareWorkspaceButton />
        <HeaderActionsMenu
          className={styles.mobileVisible}
          fileRecord={files.length === 1 ? fileRecords[0] : undefined}
        />
      </div>
      <SelectLayout
        anchorEl={layoutMenuPopup.anchor}
        isOpen={layoutMenuPopup.isOpen}
        onClose={layoutMenuPopup.close}
      />
    </>
  );
}
